<template>
  <v-container>
    <v-overlay :value="overlay" z-index="100">
      <v-progress-circular
        :size="50"
        color="grey lighten-4"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
    <v-layout row justify-center class="ma-0">
      <v-flex xs12>
        <v-card>
          <v-card-title class="align-start">
            <div class="flex-fill">
              <div class="mb-3 d-flex text-center">
                <v-btn
                  class="mr-2"
                  elevation="0"
                  text
                  color="primary"
                  @click="desativarPorId"
                >
                  <template v-if="cardapio.desativar === 'S'">
                    <v-icon left>mdi-eye</v-icon>
                    <span>Ativar</span>
                  </template>
                  <template v-else>
                    <v-icon left>mdi-eye-off</v-icon>
                    <span>Desativar</span>
                  </template>
                </v-btn>
                <v-btn
                  class="mr-2"
                  elevation="0"
                  text
                  color="primary"
                  :to="`/refeicoes/${cardapio.id}/editar`"
                  :disabled="cardapio.desativar === 'S' ? true : false"
                >
                  <v-icon left>mdi-pencil</v-icon>
                  <span>Editar</span>
                </v-btn>
                <v-btn
                  class="mr-2"
                  elevation="0"
                  text
                  color="error"
                  @click="$refs.delete.request(cardapio.id)"
                  :disabled="cardapio.status == 'E'"
                >
                  <v-icon left>mdi-delete</v-icon>
                  <span>Excluir</span>
                </v-btn>
                <v-spacer />
                <v-btn
                  elevation="0"
                  color="primary"
                  @click="enviar"
                  :disabled="
                    cardapio.status == 'R' ||
                    cardapio.desativar == 'S' ||
                    cardapio.status == 'P'
                      ? true
                      : false
                  "
                >
                  <span>Enviar</span>
                  <v-icon right small>mdi-send</v-icon>
                </v-btn>
              </div>
              <v-divider />
              <header class="mb-2">
                <p class="title primary--text mt-3 mb-0">
                  <v-icon color="primary" left>mdi-file-document-edit</v-icon>
                  <span>{{ cardapio.titulo }}</span>
                </p>
                <v-chip small class="mr-2">
                  <v-icon small left>mdi-calendar</v-icon>
                  <span>{{ moment(cardapio.data).format('LL') }}</span>
                </v-chip>
                <v-chip
                  small
                  v-for="t in cardapio.turma"
                  :key="t.id"
                  class="mr-2"
                >
                  <v-icon small left>mdi-google-classroom</v-icon>
                  <span>
                    {{
                      [
                        _.result(t, 'serie.nome'),
                        _.result(t, 'nome'),
                        _.result(t, 'serie.nivel.nome')
                      ].join(' ')
                    }}
                  </span>
                </v-chip>
                <v-chip
                  v-if="cardapio.enviar === '0'"
                  avatar
                  small
                  class="ml-2"
                >
                  <v-icon left small>mdi-account</v-icon>
                  <span>Aluno</span>
                </v-chip>
                <v-chip
                  v-else-if="cardapio.enviar === '1'"
                  avatar
                  small
                  class="ml-2"
                >
                  <v-icon left small>mdi-account-child</v-icon>
                  <span>Responsável</span>
                </v-chip>
                <v-chip
                  v-else-if="cardapio.enviar === '2'"
                  avatar
                  small
                  class="mr-2"
                >
                  <v-icon left small>mdi-account-multiple</v-icon>
                  <span>Ambos</span>
                </v-chip>
                <v-chip
                  v-if="cardapio.desativar === 'S'"
                  dark
                  avatar
                  small
                  class="mr-2"
                >
                  <v-icon left small>mdi-eye-off</v-icon>
                  <span>Desativado</span>
                </v-chip>
                <v-chip
                  v-if="cardapio.desativar === 'N'"
                  avatar
                  small
                  class="mr-2"
                >
                  <v-icon left small>mdi-eye</v-icon>
                  <span>Ativo</span>
                </v-chip>
                <v-chip
                  v-if="cardapio.status === 'E' && cardapio.desativar === 'N'"
                  color="success"
                  avatar
                  small
                >
                  <v-icon left small>mdi-check</v-icon>
                  <span>Publicado</span>
                </v-chip>
              </header>
            </div>
          </v-card-title>
          <v-card-text>
            <div class="cardapio" v-html="cardapio.descricao"></div>
          </v-card-text>

          <v-card-text>
            <section class="mt-3">
              <v-divider class="my-3" />
              <p class="title primary--text">
                <v-icon color="primary" left>mdi-calendar-clock</v-icon>
                <span>Itens Adicionados</span>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">ID</th>
                        <th class="text-left">Dia</th>
                        <th class="text-left">Tipo</th>
                        <th class="text-left">Conteúdo</th>
                        <th class="text-left">Produtos</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, c) in items" :key="c">
                        <td>{{ c + 1 }}</td>
                        <td v-if="item.dia == 1">Domingo</td>
                        <td v-if="item.dia == 2">Segunda</td>
                        <td v-if="item.dia == 3">Terça</td>
                        <td v-if="item.dia == 4">Quarta</td>
                        <td v-if="item.dia == 5">Quinta</td>
                        <td v-if="item.dia == 6">Sexta</td>
                        <td v-if="item.dia == 7">Sábado</td>

                        <td>{{ item.cardapio_item_tipo.nome }}</td>
                        <td>{{ item.conteudo }}</td>
                        <td>
                          <v-chip
                            v-for="produto in item.produto"
                            :key="produto.id"
                            small
                            class="mr-1 mb-1"
                          >{{ produto.nome }}</v-chip>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </p>
            </section>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <confirm ref="delete" :confirm-fn="remove"
      >Deseja excluir esta cardapio?</confirm
    >
    <v-snackbar v-model="snackbar" :color="cor ? cor : ''">
      {{ text }}
      <v-btn color="primary" text @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { Cardapio } from '../../service'
import Confirm from '../../components/Confirm'
export default {
  components: { Confirm },
  data() {
    return {
      overlay: false,
      cor: '',
      snackbar: false,
      text: '',
      dialog: false,
      id: this.$route.params.id,
      cardapio: {},
      escola: localStorage.getItem('escola')
        ? localStorage.getItem('escola')
        : '',
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
      menu: false,
      time: this.moment().format('HH:mm'),
      menu2: false,
      modal2: false,
      items: [],
      agenda: {
        id_item: this.$route.params.id,
        funcao_id: '',
        horario_data_envio: this.date
      },
      agendados: [],
      files: { data: [] },
      capas: { data: [] }
    }
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date)
    }
  },
  watch: {
    $route(to) {
      this.id = to.params.id
    },
    date() {
      this.dateFormatted = this.formatDate(this.date)
    }
  },
  async created() {
    this.overlay = true
    await this.load()
    this.overlay = false
  },
  methods: {
    async remove() {
      await Cardapio.delete(this.cardapio.id, { escola: this.escola })
      this.$router.back()
    },
    async load() {
      this.cardapio = await Cardapio.findByIdProduto(this.id, {
        escola: this.escola
      })
      this.agenda.funcao_id = this.cardapio.funcao_id
      this.items = this.cardapio.cardapio_item.slice().sort((a, b) => a.dia - b.dia)
    },

    async enviar() {
      try {
        await Cardapio.enviar(
          this.cardapio.id,
          this.cardapio.turma.map(({ id }) => id),
          { escola: this.escola }
        )
        await this.load()
        this.snackbar = true
        this.text = 'Refeição enviada com sucesso'
      } catch (e) {
        this.snackbar = true
        this.text = 'Houve um erro ao enviar a refeição'
        this.cor = 'red'
      }
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate(date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    async desativarPorId() {
      this.cardapio = await Cardapio.desativarPorID(
        this.cardapio.id,
        this.escola
      )
    }
  }
}
</script>

<style></style>
